// extracted by mini-css-extract-plugin
module.exports = {"loans_list":"styles_loans_list__P_Yah","iframe_loader":"styles_iframe_loader__24pND","iframe":"styles_iframe__Ksj9D","iframe_visible":"styles_iframe_visible__t6OV9"};